import React from "react";

export const IconDeskspace = ({ handleClick = false }) => (
  <svg
    fill="none"
    viewBox="0 0 24 24"
    onClick={() => (handleClick ? handleClick() : null)}
  >
    <path
      d="m20.243 4.5h-16.487c-0.83205 0-1.5066 0.67451-1.5066 1.5066v11.237c0 0.8321 0.67451 1.5066 1.5066 1.5066h16.487c0.8321 0 1.5066-0.6745 1.5066-1.5066v-11.237c0-0.83205-0.6745-1.5066-1.5066-1.5066z"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path d="m0.75 19.5h22.5-22.5z" fill="#000" />
    <path
      d="m0.75 19.5h22.5"
      stroke="#000"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
  </svg>
);

export default IconDeskspace;
